import React from 'react';

import MilestoneInt from '../MilestoneInt/MilestoneInt';
import ChecklistInt from '../ChecklistInt/ChecklistInt';
import ToolsInt from '../ToolsInt/ToolsInt';
import TasksInt from '../TasksInt';
import LeaderboardInt from '../LeaderboardInt';
import OverViewInt from "../OverviewInt/OverviewInt";


function ContentInt(props) {
	const { data, activeTab, swipeActions, setNav,  scrollNav } = props;
	switch (activeTab?.key) {
		case 'overview':
			return <OverViewInt data={data} swipeActions={swipeActions} scrollNav={scrollNav} />;
		case 'milestones':
			return <MilestoneInt data={data?.peakDayCard} swipeActions={swipeActions} />;
		case 'tools':
			return <ToolsInt data={data?.toolsPage} bottomCard={data?.bottomCard} campaignOrg={data?.campaignOrg} swipeActions={swipeActions} />;
		case 'checklist':
			return (
				<ChecklistInt
					checklist={data?.checklist}
					bottomCard={data?.bottomCard}
					campaignOrg={data?.campaignOrg}
					swipeActions={swipeActions}
					scrollNav={scrollNav} />
			);
		case 'leaderboard':
			return (
				<LeaderboardInt
					data={data?.rankingsPage}
					myorg={data?.campaignOrg?.orgName}
					swipeActions={swipeActions}
					scrollNav={scrollNav}
				/>
			);
		case 'tasks':
			return (
				<TasksInt
					data={data?.statCard}
					bottomCard={data?.bottomCard}
					stickersCard={data?.stickersCard}
					campaignOrg={data?.campaignOrg}
					scrollNav={scrollNav}
					swipeActions={swipeActions}
				/>
			);

		default:
			return <div>nothing to show</div>;
	}
}

export default ContentInt;





// import React from 'react';

// import MilestoneInt from '../MilestoneInt/MilestoneInt';
// import ChecklistInt from '../ChecklistInt/ChecklistInt';
// import ToolsInt from '../ToolsInt/ToolsInt';
// import TasksInt from '../TasksInt';
// import LeaderboardInt from '../LeaderboardInt';
// import RewardsInt from '../RewardsInt/RewardsInt';

// function ContentInt(props) {
// 	const { data, activeTab, swipeActions, setNav } = props;
// 	switch (activeTab?.key) {
// 		case 'milestones':
// 			return <MilestoneInt data={data?.peakDay} swipeActions={swipeActions} />;
// 		case 'tools':
// 			return <ToolsInt data={data?.toolsCard} swipeActions={swipeActions} />;
// 		case 'checklist':
// 			return (
// 				<ChecklistInt data={data?.checklist} swipeActions={swipeActions} />
// 			);
// 		case 'leaderboard':
// 			return (
// 				<LeaderboardInt
// 					data={data?.rankings}
// 					myorg={data?.campaignOrg?.orgName}
// 					swipeActions={swipeActions}
// 				/>
// 			);
// 		case 'tasks':
// 			return <TasksInt data={data?.statCard} swipeActions={swipeActions} />;
// 		case 'rewards':
// 			return (
// 				<RewardsInt
// 					data={data?.awardsCard}
// 					swipeActions={swipeActions}
// 					setNav={setNav}
// 				/>
// 			);
// 		default:
// 			return <div>nothing to show</div>;
// 	}
// }

// export default ContentInt;
// case 'redeem':
// 	return (
// 		<RedeemInt
// 			data={data?.redeemPage}
// 			orgdata={data?.campaignOrg}
// 			swipeActions={swipeActions}
// 			setNav={setNav}
// 		/>
// 	);
// case 'rewards':
// 	return (
// 		<RewardsInt
// 			data={data?.awardsCard}
// 			swipeActions={swipeActions}
// 			setNav={setNav}
// 		/>
// 	);
